export const LANDING_HTML = String.raw`<!-- Iconos reutilizables -->
<svg width="0" height="0" style="position:absolute" aria-hidden="true">
  <symbol id="paw" viewBox="0 0 32 32"><ellipse cx="7.5" cy="13" rx="3.2" ry="4.2" fill="#d4622b"/><ellipse cx="14" cy="7.5" rx="3.2" ry="4.4" fill="#d4622b"/><ellipse cx="22" cy="7.5" rx="3.2" ry="4.4" fill="#d4622b"/><ellipse cx="28" cy="13" rx="3" ry="4.2" fill="#d4622b" transform="translate(-2 0)"/><path d="M16 14c-4.6 0-9 4.6-9 8.6 0 2.6 2 4.4 4.6 4.4 1.8 0 2.8-.9 4.4-.9s2.6.9 4.4.9c2.6 0 4.6-1.8 4.6-4.4 0-4-4.4-8.6-9-8.6z" fill="#d4622b"/></symbol>
  <symbol id="check" viewBox="0 0 24 24"><path d="M5 12.5l4.5 4.5L19 7.5"/></symbol>
</svg>

<header class="header">
  <div class="wrap">
    <a class="logo" href="#inicio" aria-label="Perro Obediente en Casa"><svg><use href="#paw"/></svg>Perro Obediente en Casa</a>
    <nav class="nav" aria-label="Principal">
      <a href="#dolores">El problema</a><a href="#coleccion">Los tomos</a><a href="#bonos">Bonos</a><a href="#garantia">Garantía</a><a href="#preguntas">Preguntas</a>
    </nav>
    <a class="btn sm" href="#oferta">Quiero empezar</a>
  </div>
</header>

<main>
<!-- HERO: marca, promesa, mockup, subtitulo, CTA 1 -->
<section class="hero" id="inicio">
  <div class="wrap">
    <div class="hero-head rv">
      <span class="tagline">🐾 Entrenamiento en casa · Refuerzo positivo</span>
      <h1>Un perro que te hace caso.<span class="l2">Sin gritos. Sin castigos.</span></h1>
    </div>
    <div class="hero-body rv">
      <ul class="chips" aria-label="Qué incluye">
        <li>✉️ Acceso por correo</li><li>🐶 Cachorros y adultos</li><li>⏱️ Sesiones de 10 minutos</li><li>📄 Todo digital</li>
      </ul>
      <div class="hero-cta">
        <a class="btn xl" href="#oferta">→ Quiero mi colección ahora</a>
      </div>
      <div class="hero-price-row">
        <span class="hp-label">Pago único</span>
        <span class="hp-rule" aria-hidden="true"></span>
        <p class="hero-price" id="heroPrice"><small>ARS</small>27.990</p>
      </div>
    </div>
    <div class="mockup rv"><img src="https://lh3.googleusercontent.com/d/10pfRuzOpoivVupdNZmpzkxrwJdLtA3_I" alt="Colección Perro Obediente en Casa: 5 tomos y 3 bonos" width="1000" height="913"></div>
  </div>
</section>

<!-- PRUEBA SOCIAL (datos reales del producto) -->
<section class="stats" aria-label="La colección en números">
  <div class="wrap">
    <div class="stat rv"><b>5</b><span>Tomos paso a paso</span></div>
    <div class="stat rv"><b>3</b><span>Bonos incluidos</span></div>
    <div class="stat rv"><b>10</b><span>Minutos por sesión</span></div>
    <div class="stat rv"><b>7</b><span>Días de garantía</span></div>
  </div>
</section>

<!-- PROBLEMAS / DOLORES -->
<section class="section" id="dolores">
  <div class="wrap">
    <div class="center rv">
      <p class="eyebrow">Te suena familiar</p>
      <h2 style="margin-top:12px">¿Cuántos paseos más vas a pelear con la correa?</h2>
      <p class="lead" style="margin-top:14px">Quieres a tu perro. Pero nadie te explicó cómo enseñarle, y terminas probando consejos sueltos que se contradicen.</p>
    </div>
    <ul class="pains rv">
      <li>Tira de la correa y el paseo termina en discusión</li>
      <li>Le dices «ven» y hace como si no existieras</li>
      <li>Salta sobre las visitas y no sabes cómo frenarlo sin gritar</li>
      <li>Rompe cosas o llora cuando se queda solo</li>
      <li>Cada persona de la casa le da órdenes distintas</li>
      <li>Lees consejos en internet que se contradicen y no sabes a cuál creerle</li>
    </ul>
    <p class="punch rv">No es falta de cariño. <em>Es falta de un método.</em></p>
  </div>
</section>

<!-- SOLUCION -->
<section class="section" style="padding-top:0">
  <div class="wrap">
    <div class="reveal rv">
      <p class="eyebrow" style="justify-content:center">La solución</p>
      <h2 style="margin-top:12px">Perro Obediente en Casa: la colección completa</h2>
      <p class="lead" style="color:#c6d4cd;margin:14px auto 0">Un camino ordenado, de entender cómo aprende tu perro a mantener lo aprendido. Todo en PDF, listo para empezar hoy.</p>
      <div class="tags"><span>Tomo 1</span><span>Tomo 2</span><span>Tomo 3</span><span>Tomo 4</span><span>Tomo 5</span><span class="b">+ 3 bonos</span></div>
      <ul class="inc">
        <li><svg viewBox="0 0 24 24"><use href="#check"/></svg>Pasos cortos y ejemplos cotidianos, para personas sin experiencia</li>
        <li><svg viewBox="0 0 24 24"><use href="#check"/></svg>Sesiones de 10 minutos que entran en tu rutina</li>
        <li><svg viewBox="0 0 24 24"><use href="#check"/></svg>Listas y registros para anotar tu avance</li>
        <li><svg viewBox="0 0 24 24"><use href="#check"/></svg>Qué ajustar cuando algo no sale, sin castigos ni gritos</li>
        <li><svg viewBox="0 0 24 24"><use href="#check"/></svg>Hojas para imprimir y reglas claras para toda la casa</li>
      </ul>
      <div style="margin-top:30px"><a class="btn" href="#oferta">Quiero empezar hoy →</a></div>
    </div>
  </div>
</section>
<!-- PICKER -->
<section class="section picker" id="guia">
  <div class="wrap">
    <div class="center rv">
      <p class="eyebrow">Empieza por lo que te preocupa</p>
      <h2 style="margin-top:12px">¿Qué te pasa hoy con tu perro?</h2>
      <p class="lead" style="margin-top:14px">Elige tu situación y te mostramos dónde está la respuesta dentro de la colección.</p>
    </div>
    <div class="pick-grid">
      <div class="opts rv" role="group" aria-label="Situaciones">
        <button class="opt" data-k="caso" aria-pressed="true"><span class="em">🐾</span>No me hace caso cuando lo llamo</button>
        <button class="opt" data-k="paseo" aria-pressed="false"><span class="em">🦮</span>Tira de la correa en el paseo</button>
        <button class="opt" data-k="casa" aria-pressed="false"><span class="em">🛋️</span>Salta, muerde cosas o pide todo el tiempo</button>
        <button class="opt" data-k="solo" aria-pressed="false"><span class="em">🚪</span>Se pone mal cuando se queda solo</button>
        <button class="opt" data-k="nuevo" aria-pressed="false"><span class="em">🐶</span>Acaba de llegar a casa</button>
        <button class="opt" data-k="inicio" aria-pressed="false"><span class="em">🧭</span>No sé por dónde empezar</button>
      </div>
      <div class="result rv" id="result" aria-live="polite"></div>
    </div>
  </div>
</section>

<!-- COLECCION -->
<section class="section path" id="coleccion">
  <div class="wrap">
    <div class="center rv">
      <p class="eyebrow" style="color:var(--honey)">La colección completa</p>
      <h2 style="margin-top:12px">Cinco tomos, un solo camino</h2>
      <p class="lead" style="margin-top:14px">Cada tomo continúa donde termina el anterior. Vas de entender a tu perro a mantener lo aprendido.</p>
    </div>
    <div class="steps">
      <article class="step rv">
        <div class="num">1</div>
        <div class="cvbox"><div class="cv-css" style="background-image:url(https://lh3.googleusercontent.com/d/1ASV5Sz__Oqsnw-hftcREorzEtYSYX-rl)"><small>Tu guía completa</small><b>Tomo 1 -<br>Cómo aprende<br>tu perro</b><i></i></div></div>
        <div><h3>Cómo aprende tu perro</h3>
          <p>La base de todo: cómo aprende, qué premios elegir, cómo usar el marcador «Sí», cómo preparar la casa y cómo armar sesiones de 10 minutos.</p>
          <ul><li>Premios</li><li>Marcador</li><li>Casa preparada</li><li>Sesiones cortas</li></ul></div>
      </article>
      <article class="step rv">
        <div class="num">2</div>
        <div class="cvbox"><div class="cv-css" style="background-image:url(https://lh3.googleusercontent.com/d/1Z7Oco37JKPzbGIX7Iv7pGTRmXfEG-Q2p)"><small>Tu guía completa</small><b>Tomo 2 -<br>Obediencia<br>básica</b><i></i></div></div>
        <div><h3>Obediencia básica</h3>
          <p>Cinco conductas que usarás todos los días, enseñadas paso a paso: guiando con el premio, sin forzar el cuerpo de tu perro.</p>
          <ul><li>Nombre y atención</li><li>Sentarse</li><li>Echado</li><li>Quieto</li><li>Ven</li></ul></div>
      </article>
      <article class="step rv">
        <div class="num">3</div>
        <div class="cvbox"><img class="cv" src="https://lh3.googleusercontent.com/d/1fkGG8E25ZtYJ-s4HBAjykM14q3HcjwLI" alt="Portada Tomo 3" width="380" height="537"></div>
        <div><h3>Paseos sin tirones</h3>
          <p>Correa floja, caminar junto a ti y manejar las distracciones de la calle. Para que el paseo vuelva a ser un buen momento.</p>
          <ul><li>Equipo</li><li>Correa floja</li><li>Distracciones</li><li>Llamado con correa larga</li></ul></div>
      </article>
      <article class="step rv">
        <div class="num">4</div>
        <div class="cvbox"><img class="cv" src="https://lh3.googleusercontent.com/d/10LugJMb_vsslKSbOS3e__Pmyydr4QwKx" alt="Portada Tomo 4" width="380" height="537"></div>
        <div><h3>Convivencia en casa</h3>
          <p>Buenos hábitos dentro del hogar: saludar sin saltar, morder solo lo permitido, soltar objetos y respetar muebles y camas.</p>
          <ul><li>Saludos sin saltar</li><li>Mordisqueo</li><li>Suelta y déjalo</li><li>Lugar propio</li></ul></div>
      </article>
      <article class="step rv">
        <div class="num">5</div>
        <div class="cvbox"><img class="cv" src="https://lh3.googleusercontent.com/d/19fmS830iOFYxAjqhrt7ZcwrZzXC3txY8" alt="Portada Tomo 5" width="380" height="537"></div>
        <div><h3>Quedarse solo y mantener el progreso</h3>
          <p>Salidas y llegadas sin drama, juegos para que se entretenga solo y cómo manejar retrocesos para que lo aprendido dure.</p>
          <ul><li>Salidas y llegadas</li><li>Juguetes y juegos</li><li>Retrocesos</li><li>Seguir avanzando</li></ul></div>
      </article>
    </div>
  </div>
</section>

<!-- BONOS -->
<section class="section" id="bonos">
  <div class="wrap">
    <div class="center rv">
      <p class="eyebrow">Siempre incluidos</p>
      <h2 style="margin-top:12px">3 bonos para no empezar de cero</h2>
      <p class="lead" style="margin-top:14px">Los tomos explican qué hacer. Los bonos te lo dejan listo para usar.</p>
    </div>
    <div class="bonos">
      <article class="bono rv"><div class="ph"><img src="https://lh3.googleusercontent.com/d/17MD6LMJiLa_99Bf4L269HkHBgtsukmA_" alt="Cachorro recibiendo un premio"><span class="gift">Bono 1</span><span class="gift inc">Incluido</span></div>
        <div class="bd"><h3>Primeros 7 días en casa</h3><p>Un plan día por día para la llegada de un cachorro o perro nuevo: casa preparada, primera noche y rutinas simples.</p></div></article>
      <article class="bono rv"><div class="ph"><img src="https://lh3.googleusercontent.com/d/1-nq1Z4l-Kc3uRDwpae-BADz-8Q6fihU6" alt="Perro jugando con un juego casero"><span class="gift">Bono 2</span><span class="gift inc">Incluido</span></div>
        <div class="bd"><h3>30 juegos caseros para tu perro</h3><p>Juegos con objetos de tu casa para gastar energía, estimular su mente y fortalecer el vínculo.</p></div></article>
      <article class="bono rv"><div class="ph"><img src="https://lh3.googleusercontent.com/d/1L_MVMtdNOZUHq4I38w7EQJFCdWppFB-6" alt="Perro sentado junto a hojas del kit imprimible"><span class="gift">Bono 3</span><span class="gift inc">Incluido</span></div>
        <div class="bd"><h3>Kit imprimible para tu casa</h3><p>Hojas en PDF para imprimir: carteles para pegar en casa, tarjetas de señales, acuerdo de la casa, tablas semanales con casillas y registro de progreso.</p></div></article>
    </div>
    <div class="bsum rv"><b>Los 3 bonos vienen incluidos con tu colección</b><p>Sin costo adicional: los recibes en el mismo acceso que los 5 tomos.</p><div style="margin-top:16px"><a class="btn" href="#oferta">Quiero la colección completa →</a></div></div>
  </div>
</section>

<!-- INSIDE -->
<section class="section inside">
  <div class="wrap">
    <div class="rv">
      <p class="eyebrow">Mira cómo se usa</p>
      <h2 style="margin-top:12px">Material para usar, no solo para leer</h2>
      <p class="lead" style="margin-top:16px">El Bono 3 incluye hojas reales en PDF para imprimir y completar a mano: tablas semanales con casillas, registro de progreso, carteles y tarjetas. A la derecha tienes una muestra para probar cómo se marca.</p>
      <ul class="tick">
        <li><svg viewBox="0 0 24 24"><use href="#check"/></svg><span>Pasos cortos y ejemplos cotidianos, escritos para personas sin experiencia.</span></li>
        <li><svg viewBox="0 0 24 24"><use href="#check"/></svg><span>Listas y registros para anotar qué practicaste y cómo te fue.</span></li>
        <li><svg viewBox="0 0 24 24"><use href="#check"/></svg><span>Indicaciones de qué ajustar cuando algo no avanza.</span></li>
        <li><svg viewBox="0 0 24 24"><use href="#check"/></svg><span>Archivos en PDF que puedes guardar en tu celular o imprimir tantas veces como quieras.</span></li>
      </ul>
    </div>
    <div class="sheet rv" aria-label="Ejemplo interactivo de hoja de práctica">
      <div class="st"><b>Mi semana de práctica</b><span>Muestra del kit</span></div>
      <table>
        <thead><tr><th>Día</th><th>Mañana</th><th>Tarde</th><th>Noche</th></tr></thead>
        <tbody id="week"></tbody>
      </table>
      <div class="prog" aria-hidden="true"><i id="bar"></i></div>
      <p class="note" id="pnote">Muestra interactiva. En el kit la imprimes y marcas a mano.</p>
    </div>
  </div>
</section>

<!-- COMO EMPIEZAS -->
<section class="section">
  <div class="wrap">
    <div class="center rv"><p class="eyebrow">Así de simple</p><h2 style="margin-top:12px">Empiezas hoy, en tres pasos</h2></div>
    <div class="how">
      <div class="s rv"><div class="num">1</div><h3>Compras y recibes el acceso</h3><p>Al completar el pago te llega un correo con el acceso a todos tus archivos.</p></div>
      <div class="s rv"><div class="num">2</div><h3>Eliges por dónde empezar</h3><p>Empiezas por el Tomo 1 o por la situación que más te preocupa hoy.</p></div>
      <div class="s rv"><div class="num">3</div><h3>Entrenas 10 minutos y marcas tu avance</h3><p>Sigues los pasos, practicas con calma y anotas lo que logran tú y tu perro.</p></div>
    </div>
  </div>
</section>
<!-- PARA QUIEN -->
<section class="section">
  <div class="wrap">
    <div class="center rv"><p class="eyebrow">Sé claro con lo que esperas</p><h2 style="margin-top:12px">Para quién es esta colección</h2></div>
    <div class="who">
      <div class="box yes rv"><h3>Es para ti si…</h3>
        <ul><li>Tienes un cachorro o un perro adulto y quieres enseñarle en casa.</li><li>Nunca entrenaste a un perro y quieres pasos claros.</li><li>Prefieres el refuerzo positivo a los gritos o los castigos.</li><li>Puedes dedicar unos 10 minutos por sesión, con constancia.</li></ul></div>
      <div class="box no rv"><h3>No es lo que buscas si…</h3>
        <ul><li>Tu perro tiene agresividad grave o miedo intenso: ahí necesitas un profesional presencial.</li><li>Buscas consejos médicos o veterinarios: la colección no los incluye.</li><li>Esperas resultados de un día para otro: cada perro aprende a su ritmo.</li></ul></div>
    </div>
  </div>
</section>

<!-- OFERTA -->
<section class="section offer" id="oferta">
  <div class="wrap">
    <div class="center rv">
      <p class="eyebrow" style="color:var(--honey)">Colección completa</p>
      <h2 style="margin-top:12px;color:#fff">Elige tu colección y empieza hoy</h2>
    </div>
    <div class="card rv">
      <div class="top">Perro Obediente en Casa</div>
      <div class="in">
        <div class="tog" role="group" aria-label="País"><button id="pAR" aria-pressed="true">Argentina</button><button id="pUS" aria-pressed="false">Otros países</button></div>
        <div class="price" id="price"><small>ARS</small>27.990</div>
        <p class="pnote" id="pnote2">Pago único · Sin suscripciones</p>
        <ul class="incl">
          <li><svg viewBox="0 0 24 24"><use href="#check"/></svg>Tomo 1 · Cómo aprende tu perro</li>
          <li><svg viewBox="0 0 24 24"><use href="#check"/></svg>Tomo 2 · Obediencia básica</li>
          <li><svg viewBox="0 0 24 24"><use href="#check"/></svg>Tomo 3 · Paseos sin tirones</li>
          <li><svg viewBox="0 0 24 24"><use href="#check"/></svg>Tomo 4 · Convivencia en casa</li>
          <li><svg viewBox="0 0 24 24"><use href="#check"/></svg>Tomo 5 · Quedarse solo y mantener el progreso</li>
          <li><svg viewBox="0 0 24 24"><use href="#check"/></svg>Primeros 7 días en casa<span class="g">Bono</span></li>
          <li><svg viewBox="0 0 24 24"><use href="#check"/></svg>30 juegos caseros para tu perro<span class="g">Bono</span></li>
          <li><svg viewBox="0 0 24 24"><use href="#check"/></svg>Kit imprimible para tu casa<span class="g">Bono</span></li>
        </ul>
        <a class="btn block" id="buy" href="https://perro-obediente-en-casa.impultienda.ar/checkout">Quiero la colección completa →</a>
        <div class="trust"><span>🔒 Pago seguro</span><span>✉️ Acceso por correo</span><span>↩︎ Garantía de 7 días</span></div>
      </div>
    </div>
    <div class="guar rv" id="garantia">
      <svg viewBox="0 0 48 48"><path d="M24 4l16 6v12c0 10-7 18-16 22C15 40 8 32 8 22V10l16-6z"/><path d="M17 24l5 5 9-10"/></svg>
      <p style="margin:0"><b>Garantía de reembolso de 7 días.</b> Si en la primera semana sientes que el contenido no es lo que esperabas, pides el reembolso y listo. Sin justificarte.</p>
    </div>
  </div>
</section>

<!-- FAQ -->
<section class="section" id="preguntas">
  <div class="wrap">
    <div class="center rv"><p class="eyebrow">Preguntas frecuentes</p><h2 style="margin-top:12px">Antes de decidir</h2></div>
    <div class="faq rv">
      <details open><summary>¿Sirve para cachorros y para perros adultos?</summary><p>Sí. Los pasos son progresivos y se adaptan al nivel de aprendizaje que ya tenga tu perro, sea cachorro o adulto.</p></details>
      <details><summary>No tengo experiencia. ¿Me va a resultar difícil?</summary><p>No. Está escrito con frases cortas y ejemplos cotidianos, y cada tomo continúa desde el anterior. Tienes listas y registros para saber en qué punto estás.</p></details>
      <details><summary>¿Usa castigos, gritos o collares de fuerza?</summary><p>Nunca. Todo se basa en refuerzo positivo: premiar lo que quieres que tu perro repita, prevenir problemas y ser constante.</p></details>
      <details><summary>¿Me prometen resultados en pocos días?</summary><p>No. Cada perro aprende a su ritmo y los resultados dependen de la práctica y la constancia. La colección te da el camino, tú y tu perro lo recorren.</p></details>
      <details><summary>¿Incluye consejos médicos o trabaja la agresividad grave?</summary><p>No. Se enfoca en obediencia y convivencia cotidiana. Si tu perro tiene dolor, miedo intenso o agresividad, la colección te recomienda consultar a un veterinario o a un profesional presencial.</p></details>
      <details><summary>¿En qué formato lo recibo?</summary><p>En archivos digitales (PDF) que puedes leer en el celular, la tablet o la computadora. Los materiales del kit imprimible están pensados para imprimir y completar a mano.</p></details>
      <details><summary>¿Cómo recibo mi compra?</summary><p>Al completar el pago recibes por correo el acceso a todos tus archivos. Si tienes algún problema para abrirlos, nos escribes y lo resolvemos.</p></details>
    </div>
  </div>
</section>
<!-- COSTO DE NO TENERLO + CTA 3 -->
<section class="section" id="costo">
  <div class="wrap">
    <div class="center rv"><p class="eyebrow">Piénsalo así</p><h2 style="margin-top:12px">¿Cuánto cuesta no tener un método?</h2></div>
    <div class="vs rv">
      <div class="r h"><div>Sin la colección</div><div>Con la colección</div></div>
      <div class="r"><div>Paseos tensos, con tirones y enojo</div><div>Correa floja y paseos que vuelves a disfrutar</div></div>
      <div class="r"><div>Órdenes distintas según quién las da</div><div>Señales y reglas claras para toda la casa</div></div>
      <div class="r"><div>Consejos sueltos que se contradicen</div><div>Un solo camino, ordenado tomo por tomo</div></div>
      <div class="r"><div>Retrocesos que no sabes cómo frenar</div><div>Pasos de ajuste para cuando algo no avanza</div></div>
      <div class="r"><div>Mucho esfuerzo sin saber si avanzas</div><div>Listas y registros para ver tu progreso</div></div>
    </div>
    <p class="punch rv" style="margin-top:38px">El próximo paseo puede ser <em>diferente.</em></p>
    <div class="center rv" style="margin-top:26px"><a class="btn xl" href="#oferta">→ Quiero mi colección ahora</a><p class="fine" style="color:var(--mute)">Pago único · Garantía de 7 días · Pago seguro</p></div>
  </div>
</section>
</main>

<footer class="footer">
  <div class="wrap">
    <p class="brand">🐾 Perro Obediente en Casa</p>
    <p class="tag">Porque disfrutar a tu perro en casa no debería ser una batalla.</p>
    <p>Esta colección es material educativo de entrenamiento con refuerzo positivo. No reemplaza la consulta con un veterinario ni con un profesional presencial. Los resultados dependen de la constancia y del ritmo de cada perro; no se garantizan.</p>
    <div class="row"><span>© 2026 Aura Content. Todos los derechos reservados.</span><span>Pago seguro</span></div>
  </div>
</footer>

<div class="sticky" id="sticky"><a class="btn block" href="#oferta">Quiero la colección completa →</a></div>
`;
